import { render, staticRenderFns } from "./TimeLine.vue?vue&type=template&id=4837ca80&scoped=true"
import script from "./TimeLine.vue?vue&type=script&lang=js"
export * from "./TimeLine.vue?vue&type=script&lang=js"
import style0 from "./TimeLine.vue?vue&type=style&index=0&id=4837ca80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4837ca80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline})
